// 3rd party imports
import * as React from 'react';
import * as fetch from 'isomorphic-fetch';

//bernie
import { ContextStore, ExperimentStore, PageStore } from 'bernie-core';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

// shared ui
import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

// uitk
import { ESSAdapter, TypeaheadSelection, UitkTypeahead } from 'uitk-react-typeahead';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkTextArea, UitkTextInput } from 'uitk-react-input';
import { UitkHeading } from 'uitk-react-text';
import { UitkSelect } from 'uitk-react-select';
import { UitkCheckbox, UitkToggleSwitch } from 'uitk-react-switch';
import { UitkButtonToggle } from 'uitk-react-button-toggle';
import { UitkLayoutGridItem, UitkLayoutGrid } from 'uitk-react-layout-grid';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';

//utils
import { hasValidDateRange, isValidDateFormat } from '../../../../util/DatesUtil';

// components
import Loader from '../../common/loader';
import { CopyLinkButton } from '../../common/copy-link-button';
import { TestLinkButton } from '../../common/test-link-button';
import { RoomComponent } from './room-component';
import { ChildComponent } from './child-component';

// Stores
import { LinkStore } from 'stores';

// Models
import { LinkAnalyticsMicroMessageContent } from 'models/analytics';

//enums
import { LinkType } from 'models/analytics/enums';
import { LOBType } from 'components/deeplink-builder/enums';

export interface TypeaheadSelectionProps {
  data: TypeaheadDataProps;
  term: string;
}

interface HierarchyInfo {
  airport: Airport;
}

interface Airport {
  airportCode: string;
  airportId: string;
  metrocode: string;
  multicity: string;
}

export interface TypeaheadDataProps {
  regionId: string;
  originId: string;
  hierarchyInfo: HierarchyInfo;
  selectedLocation: string;
}

export interface HotelLobSearchProps extends LocalizedComponentProps {
  link: LinkStore;
  analyticsTrackEvents?: (rffr: string, link: LinkAnalyticsMicroMessageContent) => void;
}

@withLocalization
export class HotelLobSearch extends React.Component<HotelLobSearchProps, any> {
  public constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onDaysInFutureChange = this.onDaysInFutureChange.bind(this);
    this.onLengthofStayChange = this.onLengthofStayChange.bind(this);
    this.onRoomCountChange = this.onRoomCountChange.bind(this);
    this.onAdultCountChange = this.onAdultCountChange.bind(this);
    this.onChildCountChange = this.onChildCountChange.bind(this);
    this.onAgeChange = this.onAgeChange.bind(this);
    this.renderRoom = this.renderRoom.bind(this);
    this.handlePin = this.handlePin.bind(this);
    this.handleHotelId = this.handleHotelId.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleDateField = this.handleDateField.bind(this);
    this.renderPaymentTypes = this.renderPaymentTypes.bind(this);
    this.handlePaymentChange = this.handlePaymentChange.bind(this);
    this.state = {
      openVal: false,
      startDate: '',
      endDate: '',
      daysInFuture: '',
      lengthOfStay: '',
      roomStateChange: false,
      roomCount: 1,
      roomComponents: [],
      numAdults: {
        adultCount1: 1,
        adultCount2: 0,
        adultCount3: 0,
        adultCount4: 0,
        adultCount5: 0,
        adultCount6: 0,
        adultCount7: 0,
        adultCount8: 0,
      },
      numChild: {
        childCount1: 0,
        childCount2: 0,
        childCount3: 0,
        childCount4: 0,
        childCount5: 0,
        childCount6: 0,
        childCount7: 0,
        childCount8: 0,
      },
      childDetails: { child1: [], child2: [], child3: [], child4: [] },
      childAge1: [-1, -1, -1, -1, -1, -1],
      childAge2: [-1, -1, -1, -1, -1, -1],
      childAge3: [-1, -1, -1, -1, -1, -1],
      childAge4: [-1, -1, -1, -1, -1, -1],
      childAge5: [-1, -1, -1, -1, -1, -1],
      childAge6: [-1, -1, -1, -1, -1, -1],
      childAge7: [-1, -1, -1, -1, -1, -1],
      childAge8: [-1, -1, -1, -1, -1, -1],
      childStatus: false,
      childCount: 0,
      starRating: [],
      paymentOptions: [],
      allAmenity: false,
      air_condition: false,
      pool: false,
      speed: false,
      all_inclusive: false,
      parking: false,
      pets: false,
      free_transport: false,
      ocean_view: false,
      casino: false,
      breakfast: false,
      hairdryer: false,
      spa: false,
      kitchen: false,
      water_park: false,
      hot_tub: false,
      hot_spring: false,
      childComponent1: [],
      childComponent2: [],
      childComponent3: [],
      childComponent4: [],
      childComponent5: [],
      childComponent6: [],
      errors: { location: '', dates: '', actions: '' },
      error: false,
      message: '',
      RadioGroup: 'no-hotel-pin',
      hotelId: '',
      pinhotel: false,
      sort: 'recommended',
      isLoading: false,
      hideDateField: false,
      regionId: '',
    };
  }

  public handleChange(e) {
    this.setState({ value: e.target.value });
  }

  public handleDateField = (event) => {
    this.setState({
      [event.currentTarget.id]: event.currentTarget.checked,
      startDate: '',
      endDate: '',
      lengthOfStay: '',
      daysInFuture: '',
    });
  };

  public renderRoomCount = () => {
    const rooms = [1, 2, 3, 4, 5, 6, 7, 8];
    let opt;

    return rooms.map((room) => {
      if (room > 1) {
        opt = (
          <option key={room} value={room}>
            {room} Rooms
          </option>
        );
      } else {
        opt = (
          <option key={room} value={room}>
            {room} Room
          </option>
        );
      }

      return opt;
    });
  };

  public renderDaysInFutureAndLengthOfStay = () => {
    const days = ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];

    return days.map((day) => {
      return (
        <option key={day} value={day}>
          {day}
        </option>
      );
    });
  };

  public renderStarRating = () => {
    const starElements = [];
    for (let i = 1; i <= 5; i++) {
      starElements.push(
        <div key={i} className="uitk-cell">
          <UitkCheckbox id={`${i}-star`} label={`${i} Star`} onChange={this.handleStarRating} />
        </div>,
      );
    }

    return starElements;
  };

  public renderPaymentTypes = () => {
    const paymentCode = ['FREE_CANCELLATION', 'PAY_LATER'];
    const paymentTypes = { FREE_CANCELLATION: 'Free Cancellation', PAY_LATER: 'Reserve now, pay later' };
    const payElements = [];
    for (let i = 0; i < paymentCode.length; i++) {
      payElements.push(
        <div key={i} className="uitk-cell">
          <UitkCheckbox id={paymentCode[i]} label={paymentTypes[paymentCode[i]]} onChange={this.handlePaymentChange} />
        </div>,
      );
    }

    return payElements;
  };

  public handlePaymentChange = (event) => {
    const payment = [...this.state.paymentOptions];
    if (payment.includes(event.currentTarget.id)) {
      if (!event.currentTarget.checked) {
        const index = payment.indexOf(event.currentTarget.id);
        payment.splice(index, 1);
      }
    } else {
      if (event.currentTarget.checked) {
        payment.push(event.currentTarget.id);
      }
    }
    this.setState({
      paymentOptions: payment,
    });
  };

  public renderAmenities = () => {
    const amenityCode = [
      'air_condition',
      'pool',
      'speed',
      'all_inclusive',
      'parking',
      'pets',
      'free_transport',
      'ocean_view',
      'casino',
      'breakfast',
      'hairdryer',
      'spa',
      'kitchen',
      'water_park',
      'hot_tub',
      'hot_spring',
    ];
    const amenities = {
      air_condition: 'Air Condition',
      pool: 'Pool',
      speed: 'Free WiFi',
      all_inclusive: 'All inclusive',
      parking: 'Free Parking',
      pets: 'Pet friendly',
      free_transport: 'Free airport shuttle',
      ocean_view: 'Ocean View',
      casino: 'Casino',
      breakfast: 'Breakfast included',
      hairdryer: 'Washer and Dryer',
      spa: 'Spa',
      kitchen: 'Kitchen',
      water_park: 'Water park',
      hot_tub: 'Hot tub',
      hot_spring: 'Hot spring',
    };
    const amenityElements = [];
    let aCode = '';
    let amenity = '';
    for (let i = 0; i < amenityCode.length; i++) {
      aCode = amenityCode[i];
      amenity = amenities[aCode];
      amenityElements.push(
        <UitkLayoutFlexItem key={i}>
          <UitkButtonToggle labelText={amenity} id={aCode} checked={this.state[aCode]} onChange={this.handleAmenity} />
        </UitkLayoutFlexItem>,
      );
    }

    return amenityElements;
  };

  public onAdultCountChange = (event) => {
    const adultId = event.target.getAttribute('id');
    const { value } = event.target;
    const adultArray = this.state.numAdults;
    adultArray[adultId] = Number(value);
    this.setState({
      numAdults: adultArray,
    });
  };

  public onRoomCountChange = (event) => {
    let { value } = event.target;
    let statusChange = false;
    if (value > 1) {
      statusChange = true;
    }
    this.setState({
      roomCount: value,
      roomStateChange: statusChange,
    });
    const rooms = [];
    for (let i = 1; i < value; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    for (let i = Number(value) + 1; i <= 6; i++) {
      this.setState({
        [`childComponent${i}`]: [],
      });
    }
    this.setState({
      roomComponents: rooms,
    });
    const adultArray = this.state.numAdults;
    if (adultArray[`adultCount${value}`] === 0) {
      adultArray[`adultCount${value}`] = 1;
    }

    const childAgeArray = [...this.state[`childAge${value}`]];
    if (childAgeArray === []) {
      for (let i = 0; i < 6; i++) {
        childAgeArray.push(0);
      }
    }
    // tslint:disable-next-line:no-eval
    value = Number(value) + 1;
    const childArray = this.state.numChild;
    for (let i = value; i <= 6; i++) {
      adultArray[`adultCount${i}`] = 0;
      childArray[`childCount${i}`] = 0;
      this.setState({
        [`childAge${i}`]: [-1, -1, -1, -1, -1, -1],
      });
    }
    this.setState({
      numAdults: adultArray,
      numChild: childArray,
    });
  };

  public renderSortFilter() {
    const sort = [
      { key: 'recommended', value: 'Recommended' },
      { key: 'distance', value: 'Distance From Downtown' },
      { key: 'price', value: 'Price' },
      { key: 'guestRating', value: 'Guest Rating' },
      { key: 'vacationRental', value: 'Vacation Rentals' },
      { key: 'starRating', value: 'Star Rating' },
      { key: 'deals', value: 'Best Deals' },
    ];

    return sort.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public handleSort(event) {
    this.setState({
      sort: event.currentTarget.value,
    });
  }

  public renderRoom() {
    const temp = this.state.roomCount;

    const rooms = [];

    for (let i = 1; i < temp; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    this.setState({
      roomComponents: rooms,
      roomStateChange: true,
    });
    /*const rooms = [];
        for(let i=0;i<this.state.roomCount-1;i++) {
          rooms.push(this.state.roomComponents[i]);
        }
        this.setState({
          roomComponents: rooms,
          roomStateChange: true
        })*/
  }

  public onAgeChange(event) {
    const { value } = event.target;
    const childId = event.currentTarget.getAttribute('id');
    const idChar = childId.substring(9, childId.length);
    const roomNo = idChar.split('-')[0];
    const childNum = idChar.split('-')[1];
    const totalChild = idChar.split('-')[2];
    const childAge = this.state[`childAge${roomNo}`];
    childAge[childNum - 1] = value;
    this.setState({
      [`childAge${roomNo}`]: childAge,
    });
  }

  public onChildCountChange = (event) => {
    this.setState({
      roomStateChange: false,
    });
    const { value } = event.target;
    const childArray = [];
    const roomId = event.currentTarget.getAttribute('id');
    const roomNum = roomId.substring(11, roomId.length);
    const childAge = this.state[`childAge${roomNum}`];
    for (let i = 0; i < Number(value); i++) {
      childAge[i] = 0;
    }
    for (let i = Number(value); i < 8; i++) {
      childAge[i] = -1;
    }
    this.setState({
      childCount: value,
    });
    this.setState({
      [`childAge${roomNum}`]: childAge,
    });
    for (let i = 1; i <= value; i++) {
      childArray.push(
        <ChildComponent roomCount={roomNum} childCount={i} totalChild={value} onAgeChange={this.onAgeChange} />,
      );
    }
    this.setState(
      {
        [`childComponent${roomNum}`]: childArray,
      },
      () => this.renderRoom(),
    );

    const rooms = [];

    const childArray1 = this.state.numChild;
    const temp = this.state.roomCount;
    const childId = event.currentTarget.getAttribute('id');
    const childrenArray = this.state.numChild;
    const childId1 = 'childCount' + childId.substring(11, childId.length);
    childrenArray[childId1] = Number(value);
    this.setState({
      numChild: childrenArray,
    });

    for (let i = 1; i < temp; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    this.setState(
      {
        roomComponents: rooms,
        roomStateChange: true,
      },
      () => this.renderRoom(),
    );
  };

  public handleDatesChange = (event) => {
    const errors1 = this.state.errors;
    errors1['dates'] = '';
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  public validateDates(name: string) {
    const { startDate, endDate } = this.state;
    if ((!startDate && name === 'startDate') || (!endDate && name === 'endDate')) {
      return;
    }

    if (name === 'startDate' && !isValidDateFormat(startDate)) {
      return 'Please enter valid Check in date in the format mm/dd/yyyy';
    }
    if (name === 'endDate' && !isValidDateFormat(endDate)) {
      return 'Please enter valid Check out date in the format mm/dd/yyyy';
    }
  }

  public handlePin(event) {
    const errors1 = this.state.errors;
    errors1['hotelId'] = '';
    this.setState({
      errors: errors1,
    });
    if (!event.currentTarget.checked) {
      this.setState({
        hotelId: '',
      });
    }
    this.setState({
      pinHotel: event.currentTarget.checked,
    });
  }

  public handleHotelId(selection: TypeaheadSelection) {
    const errors1 = this.state.errors;
    errors1['hotelId'] = '';
    this.setState({
      errors: errors1,
      message: '',
    });
    const { data, term } = selection as TypeaheadSelectionProps;
    this.setState({ hotelId: data['selected'] });
  }

  public fetchData() {
    const destination = this.state.selectedLocation;
    const mainCategory = 'Hotels';
    const subCategory = 'hotelSearch';
    const numRoom = 1;
    const numAdult = this.state.value;
    const checkInDate = this.state.startDate;
    const checkOutDate = this.state.endDate;
    const formattedStarRating = [];
    const formattedStars = [];
    let starString = '';
    const starRatings = this.state.starRating;
    let formattedStarRatingString = '';
    const paymentOptions = this.state.paymentOptions;
    let paymentTypeString = '';

    if (paymentOptions !== undefined && paymentOptions !== null && paymentOptions.length > 0) {
      paymentTypeString = paymentTypeString + `&hotelSearch-paymentType=${paymentOptions[0]}`;
      for (let i = 1; i < paymentOptions.length; i++) {
        paymentTypeString = paymentTypeString + `,${paymentOptions[i]}`;
      }
    }

    if (starRatings !== [] && starRatings !== undefined && starRatings !== null) {
      starRatings.forEach((item) => {
        switch (item) {
          case '1-star':
            formattedStarRating.push('hotelClass=10');
            formattedStars.push('10');
            break;
          case '2-star':
            formattedStarRating.push('hotelClass=20');
            formattedStars.push('20');
            break;
          case '3-star':
            formattedStarRating.push('hotelClass=30');
            formattedStars.push('30');
            break;
          case '4-star':
            formattedStarRating.push('hotelClass=40');
            formattedStars.push('40');
            break;
          case '5-star':
            formattedStarRating.push('hotelClass=50');
            formattedStars.push('50');
            break;
        }
      });

      formattedStarRatingString = '';
      for (let i = 0; i < formattedStarRating.length; i++) {
        if (i === 0) {
          formattedStarRatingString = formattedStarRating[i];
          starString = `hotelSearch-Class=${formattedStars[i]}`;
        } else {
          formattedStarRatingString = formattedStarRatingString + `&${formattedStarRating[i]}`;
          starString = starString + `,${formattedStars[i]}`;
        }
      }
    }
    let param =
      `main-category=${mainCategory}&sub-category=${subCategory}&` +
      `hotelSearch-CityName=${destination}&` +
      `hotelSearch-InDate=${checkInDate}&hotelSearch-OutDate=${checkOutDate}&hotelSearch-SearchType=Destination`;

    if (paymentTypeString !== '') {
      param = param + paymentTypeString;
    }

    if (this.state.hotelId) {
      param = param + `&hotelSearch-hotelId=${this.state.hotelId}`;
    }

    if (this.props.link.language) {
      param =
        param +
        `&hotelSearch-marketingParam=clickid&hotelSearch-marketingParamVal=&hotelSearch-passthroughParam=langid&hotelSearch-passthroughParamVal=${this.props.link.language}`;
    } else {
      param =
        param +
        `&hotelSearch-marketingParam=clickid&hotelSearch-marketingParamVal=&hotelSearch-passthroughParam=langid&hotelSearch-passthroughParamVal=1033`;
    }

    if (formattedStarRatingString !== '') {
      param = param + `&${starString}&${formattedStarRatingString}`;
    }

    let adultArrayString = '';

    const adultsArray = this.state.numAdults;
    if (adultsArray !== [] && adultsArray!) {
      let key = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `adultCount${i}`;
        if (this.state.childCount <= 0) {
          if (i === 1) {
            adultArrayString =
              adultArrayString + `hotelSearch-NumAdult${i}=${adultsArray[key]}&hotelSearch-NumChild${i}=0`;
          } else {
            adultArrayString =
              adultArrayString + `&hotelSearch-NumAdult${i}=${adultsArray[key]}&&hotelSearch-NumChild${i}=0`;
          }
        } else {
          if (i === 1) {
            adultArrayString = adultArrayString + `hotelSearch-NumAdult${i}=${adultsArray[key]}`;
          } else {
            adultArrayString = adultArrayString + `&hotelSearch-NumAdult${i}=${adultsArray[key]}`;
          }
        }
      }
    }
    if (adultArrayString !== '') {
      param = param + `&hotelSearch-NumRoom=${this.state.roomCount}&${adultArrayString}`;
    }

    let child = '';
    let childCount = 0;
    if (this.state.childCount > 0) {
      let key = '';
      let key2 = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `childCount${i}`;
        child = child + `&hotelSearch-NumChild${i}=` + this.state.numChild[key];
      }
      for (let i = 1; i <= this.state.roomCount; i++) {
        childCount = this.state.numChild[`childCount${i}`];
        for (let j = 0; j < childCount; j++) {
          key2 = this.state[`childAge${i}`];
          child = child + `&hotelSearch-Rm${i}child${j + 1}age=` + key2[j];
        }
      }
    }

    if (child !== '') {
      param = param + child;
    }

    let amenityFilterString = '';
    if (this.state.allAmenity) {
      amenityFilterString =
        `hotelSearch-AmenityFilter[]=27&hotelSearch-AmenityFilter[]=7&hotelSearch-AmenityFilter[]=19` +
        `&hotelSearch-AmenityFilter[]=30&hotelSearch-AmenityFilter[]=14&hotelSearch-AmenityFilter[]=17` +
        `&hotelSearch-AmenityFilter[]=66&hotelSearch-AmenityFilter[]=72&hotelSearch-AmenityFilter[]=75` +
        `&hotelSearch-AmenityFilter[]=16&hotelSearch-AmenityFilter[]=76&hotelSearch-AmenityFilter[]=74` +
        `&hotelSearch-AmenityFilter[]=77&hotelSearch-AmenityFilter[]=71&hotelSearch-AmenityFilter[]=70` +
        `&hotelSearch-AmenityFilter[]=78`;
    } else {
      const amenities = [
        this.state.air_condition,
        this.state.pool,
        this.state.speed,
        this.state.all_inclusive,
        this.state.parking,
        this.state.pets,
        this.state.free_transport,
        this.state.ocean_view,
        this.state.casino,
        this.state.breakfast,
        this.state.hairdryer,
        this.state.spa,
        this.state.kitchen,
        this.state.water_park,
        this.state.hot_tub,
        this.state.hot_spring,
      ];
      const amenityNumber = [27, 7, 19, 30, 14, 17, 66, 72, 75, 16, 76, 74, 77, 71, 70, 78];
      const amenityIndex = [];
      for (let i = 0; i < amenities.length; i++) {
        if (amenities[i]) {
          amenityIndex.push(i);
        }
      }
      if (amenityIndex.length > 0) {
        amenityFilterString = `hotelSearch-AmenityFilter[]=${amenityNumber[amenityIndex[0]]}`;
      }
      if (amenityIndex.length > 1) {
        for (let i = 1; i < amenityIndex.length; i++) {
          amenityFilterString = amenityFilterString + `&hotelSearch-AmenityFilter[]=${amenityNumber[amenityIndex[i]]}`;
        }
      }
    }
    if (amenityFilterString !== '') {
      param = param + `&${amenityFilterString}`;
    }

    if (this.state.daysInFuture !== '' && this.state.lengthOfStay !== '') {
      param =
        param +
        `&hotelSearch-DaysInFuture=${this.state.daysInFuture}&hotelSearch-StayLength=${this.state.lengthOfStay}`;
    }

    if (this.props.link.channel === 'Commission Junction') {
      if (this.props.link.pid || this.props.link.sid) {
        param = param + `&hotelSearch-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.pid && this.props.link.pid) {
        param = param + `&hotelSearch-pid=${this.props.link.pid}`;
      }
      if (this.props.link.sid && this.props.link.sid) {
        param = param + `&hotelSearch-sid=${this.props.link.sid}`;
      }
    }

    if (this.props.link.channel === 'PHG') {
      if (this.props.link.camRef || this.props.link.adRef || this.props.link.creativeRef || this.props.link.pubRef) {
        param = param + `&hotelSearch-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.camRef && this.props.link.camRef) {
        param = param + `&hotelSearch-camref=${this.props.link.camRef}`;
      }
      if (this.props.link.adRef && this.props.link.adRef) {
        param = param + `&hotelSearch-adref=${this.props.link.adRef}`;
      }
      if (this.props.link.creativeRef && this.props.link.creativeRef) {
        param = param + `&hotelSearch-creativeref=${this.props.link.creativeRef}`;
      }
      if (this.props.link.pubRef && this.props.link.pubRef) {
        param = param + `&hotelSearch-pubref=${this.props.link.pubRef}`;
      }
    }

    param = param + `&hotelSearch-SortBy=${this.state.sort}`;

    const url = `/api/paandi/marketing-tools/geturl?${param}`;

    return fetch(url, {
      method: 'GET',
    })
      .then((res) =>
        res.text().then((response) => {
          return response;
        }),
      )
      .catch((err) => ({
        error: err,
      }));
  }

  public handleClick() {
    this.setState({
      link: '',
    });
    let isError = false;
    const errors1 = {};
    if (this.state.selectedLocation === '' || this.state.selectedLocation === undefined) {
      isError = true;
      errors1['location'] = 'Please enter a destination';
    }
    if (this.state.startDate === '' && this.state.endDate === '') {
      if (this.state.daysInFuture === '' && this.state.lengthOfStay === '') {
        isError = true;
        errors1['dates'] = 'Please enter your dates';
      }
    }
    if (!!this.state.startDate && !this.state.endDate) {
      isError = true;
      errors1['dates'] = 'Please enter Check out date';
    }
    if (!this.state.startDate && !!this.state.endDate) {
      isError = true;
      errors1['dates'] = 'Please enter Check in date';
    }
    if (
      !!this.state.startDate &&
      !!this.state.endDate &&
      !hasValidDateRange(this.state.startDate, this.state.endDate)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter valid dates';
    }
    if (
      !!this.state.startDate &&
      !!this.state.endDate &&
      !hasValidDateRange(this.state.startDate, this.state.endDate)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter valid dates';
    }
    if (this.state.pinHotel && (this.state.hotelId === '' || this.state.hotelId === undefined)) {
      isError = true;
      errors1['hotelId'] = 'Please select the hotel';
    }
    this.setState({
      error: isError,
      errors: errors1,
      message: isError ? 'Form contains errors! Please correct it and proceed' : '',
    });
    if (!isError) {
      this.setState({
        isLoading: true,
      });
      this.fetchData().then((data) => {
        this.setState({
          link: data.toString(),
          isLoading: false,
        });
      });
    }
    if (isError) {
      window.scrollTo(0, 0);
    }
  }

  public handleLocationChange = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['location'] = '';
    this.setState({
      errors: errors1,
      message: '',
    });
    const { data, term } = selection as TypeaheadSelectionProps;

    this.setState({
      selectedLocation: term,
      regionId: data.regionId,
    });
  };

  public onDaysInFutureChange = (event) => {
    const { value } = event.target;
    const error1 = this.state.errors;
    error1['dates'] = '';
    this.setState({
      errors: error1,
    });
    this.setState({
      daysInFuture: value,
    });
  };

  public onLengthofStayChange = (event) => {
    const { value } = event.target;
    const error1 = this.state.errors;
    error1['dates'] = '';
    this.setState({
      errors: error1,
    });
    this.setState({
      lengthOfStay: value,
    });
  };

  public handleStarRating = (event) => {
    const starRating1 = [...this.state.starRating];
    if (starRating1.includes(event.currentTarget.id)) {
      if (!event.currentTarget.checked) {
        const index = starRating1.indexOf(event.currentTarget.id);
        starRating1.splice(index, 1);
      }
    } else {
      if (event.currentTarget.checked) {
        starRating1.push(event.currentTarget.id);
      }
    }
    this.setState({
      starRating: starRating1,
    });
  };

  public handleAmenity = (event) => {
    if (!event.currentTarget.checked) {
      this.setState({
        allAmenity: false,
      });
    }
    if (event.currentTarget.id === 'all_amenity') {
      this.setState({
        allAmenity: event.currentTarget.checked,
        air_condition: event.currentTarget.checked,
        pool: event.currentTarget.checked,
        speed: event.currentTarget.checked,
        all_inclusive: event.currentTarget.checked,
        parking: event.currentTarget.checked,
        pets: event.currentTarget.checked,
        free_transport: event.currentTarget.checked,
        ocean_view: event.currentTarget.checked,
        casino: event.currentTarget.checked,
        breakfast: event.currentTarget.checked,
        hairdryer: event.currentTarget.checked,
        spa: event.currentTarget.checked,
        kitchen: event.currentTarget.checked,
        water_park: event.currentTarget.checked,
        hot_tub: event.currentTarget.checked,
        hot_spring: event.currentTarget.checked,
      });
    }
    this.setState({
      [event.currentTarget.id]: event.currentTarget.checked,
    });
  };

  public render() {
    const roomComponent = (
      <RoomComponent
        onAdultCountChange={this.onAdultCountChange}
        onChildCountChange={this.onChildCountChange}
        roomCount="1"
        childComponent={this.state[`childComponent1`]}
      />
    );

    return (
      <>
        <span style={{ color: 'red' }}>{this.state.message}</span>
        <UitkHeading tag="h2" size={5}>
          Choose your Destination
        </UitkHeading>
        <UitkTypeahead
          adapter={
            new ESSAdapter({
              client: 'Homepage',
              dest: true,
              domain: 'https://www.expedia.com/',
              expuserid: -1,
              features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
              guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
              lob: 'HOTELS',
              locale: 'en_US',
              maxResults: 10,
              personalize: false, // change to true to see recent searches
              regionType: 2047,
              siteId: 1,
            })
          }
          label="Select the Destination"
          id="hotelLocation"
          name="hotelLocation"
          icon="place"
          onUpdate={this.handleLocationChange}
        />
        <span style={{ color: 'red' }}>{this.state.errors['location']}</span>
        <UitkSpacingHr />

        <UitkHeading tag="h2" size={5}>
          Select Your Dates
        </UitkHeading>
        <p>Create your deeplink by entering a specific date range or by searching 1-11 days in the future.</p>

        <Viewport>
          <ViewLarge>
            <UitkToggleSwitch
              id="hideDateField"
              checked={this.state.hideDateField}
              onChange={this.handleDateField}
              label="Pick Date Selection Type"
              labelClassName="uitk-type-500"
            />
          </ViewLarge>
          <ViewSmall>
            <UitkToggleSwitch
              id="hideDateField"
              checked={this.state.hideDateField}
              onChange={this.handleDateField}
              label="Pick Date Selection Type"
              labelClassName="uitk-type-500"
            />
          </ViewSmall>
        </Viewport>
        {this.state.hideDateField ? (
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkSelect id="days-in-future" label="Days in the future" onChange={this.onDaysInFutureChange}>
                    {this.renderDaysInFutureAndLengthOfStay()}
                  </UitkSelect>
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkSelect id="length-of-stay" label="Length of Stay" onChange={this.onLengthofStayChange}>
                    {this.renderDaysInFutureAndLengthOfStay()}
                  </UitkSelect>
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        ) : (
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="startDate"
                    label="Check In"
                    placeholder="mm/dd/yyyy"
                    name="startDate"
                    value={this.state.startDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('startDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="endDate"
                    label="Check Out"
                    placeholder="mm/dd/yyyy"
                    name="endDate"
                    value={this.state.endDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('endDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        )}
        <span style={{ color: 'red' }}>{this.state.errors['dates']}</span>

        <UitkSpacingHr />

        <UitkSpacing margin={{ block: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Who is Travelling?
          </UitkHeading>
        </UitkSpacing>
        <Viewport>
          <ViewLarge>
            <UitkLayoutGrid columns={2} space="three">
              <>
                <UitkLayoutGridItem>
                  <div>
                    <UitkSelect
                      id="room-count"
                      label=""
                      icon="room"
                      onChange={this.onRoomCountChange}
                      hasVisibleLabel={false}
                    >
                      {this.renderRoomCount()}
                    </UitkSelect>
                  </div>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <div>
                    {roomComponent}
                    {this.state.roomStateChange ? this.state.roomComponents : ''}
                  </div>
                </UitkLayoutGridItem>
              </>
            </UitkLayoutGrid>
          </ViewLarge>
          <ViewSmall>
            <>
              <UitkSelect
                id="room-count"
                label=""
                icon="room"
                onChange={this.onRoomCountChange}
                hasVisibleLabel={false}
              >
                {this.renderRoomCount()}
              </UitkSelect>
              <UitkSpacing margin={{ block: 'three' }}>
                <div>
                  {roomComponent}
                  {this.state.roomStateChange ? this.state.roomComponents : ''}
                </div>
              </UitkSpacing>
            </>
          </ViewSmall>
        </Viewport>
        <UitkSpacingHr />
        <UitkSpacing margin={{ block: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Are There Any More Details?
          </UitkHeading>
        </UitkSpacing>
        <UitkLayoutGrid columns={2}>
          <>
            <UitkLayoutGridItem>
              <div>
                <UitkHeading tag="h2" size={5}>
                  Star Rating
                </UitkHeading>
                {this.renderStarRating()}
              </div>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem>
              <div>
                <UitkHeading tag="h2" size={5}>
                  Amenities*
                </UitkHeading>
                <UitkToggleSwitch
                  id="all_amenity"
                  checked={this.state.allAmenity}
                  onChange={this.handleAmenity}
                  label="All amenities"
                />
                <UitkLayoutFlex wrap="wrap" className="deeplink-builder__all-amenities" space="two">
                  <>{this.renderAmenities()}</>
                </UitkLayoutFlex>
                <p>*Some destinations do not support all Amenity types, please test your deeplink before using.</p>
              </div>
            </UitkLayoutGridItem>
          </>
        </UitkLayoutGrid>
        <UitkSpacing margin={{ block: 'three' }}>
          <div>
            <UitkHeading tag="h2" size={5}>
              Payment Type
            </UitkHeading>
            {this.renderPaymentTypes()}
          </div>
        </UitkSpacing>
        <UitkSpacing margin={{ block: 'three' }}>
          <UitkLayoutGrid columns={2}>
            <>
              <UitkLayoutGridItem>
                <UitkToggleSwitch
                  id="pin_a_hotel"
                  checked={this.state.pinHotel}
                  onChange={this.handlePin}
                  label="Pin a Hotel to Top of Search Results?"
                />
              </UitkLayoutGridItem>

              {this.state.pinHotel ? (
                <UitkLayoutGridItem>
                  <UitkTypeahead
                    adapter={
                      new ESSAdapter({
                        client: 'lodging',
                        dest: true,
                        domain: 'https://www.expedia.com/',
                        expuserid: -1,
                        features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                        guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                        lob: 'HOTELS',
                        locale: 'en_US',
                        maxResults: 10,
                        personalize: false, // change to true to see recent searches
                        regionId: this.state.regionId,
                        regionType: 128,
                        siteId: 1,
                      })
                    }
                    label="Select the Hotel"
                    name="hotelLocation"
                    icon="lob_hotels"
                    onUpdate={this.handleHotelId}
                  />
                  <span style={{ color: 'red' }}>{this.state.errors['hotelId']}</span>
                </UitkLayoutGridItem>
              ) : (
                ''
              )}
            </>
          </UitkLayoutGrid>
        </UitkSpacing>
        <UitkLayoutGrid columns={2} alignItems="center">
          <>
            <UitkLayoutGridItem>
              <UitkHeading tag="h2" size={5}>
                Default Sort
              </UitkHeading>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem>
              <UitkSelect label="" onChange={this.handleSort} hasVisibleLabel={false}>
                {this.renderSortFilter()}
              </UitkSelect>
            </UitkLayoutGridItem>
          </>
        </UitkLayoutGrid>
        <UitkSpacing margin={{ block: 'three' }}>
          <UitkPrimaryButton name="buildlink" type="button" onClick={this.handleClick} isFullWidth={true}>
            Build Deeplink
          </UitkPrimaryButton>
        </UitkSpacing>
        <UitkSpacing margin={{ block: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Here is your Deeplink
          </UitkHeading>
        </UitkSpacing>

        {this.state.isLoading ? (
          <Loader />
        ) : (
          <UitkTextArea id="deeplink_holder" label="" name="deeplink_holder" value={this.state.link} />
        )}

        <UitkSpacing margin={{ block: 'three' }}>
          <div>
            <span style={{ color: 'red' }}>{this.state.errors['actions']}</span>
            <UitkLayoutFlex space="three">
              <>
                <CopyLinkButton
                  link={this.state.link}
                  onSuccess={() => {
                    this.props.analyticsTrackEvents('affhub_copy_link.selected', {
                      linkType: LinkType.CUSTOM,
                      linkIndex: LOBType.HOTEL_SEARCH,
                      linkTargetUrl: this.state.link,
                    });
                  }}
                  onFailure={() => {
                    this.setState((prevState) => ({
                      error: true,
                      errors: {
                        ...prevState.errors,
                        actions: this.props.l10n.formatText('deeplink-builder.actions.copy.error'),
                      },
                    }));
                  }}
                />
                <TestLinkButton
                  link={this.state.link}
                  onFailure={() => {
                    this.setState((prevState) => ({
                      error: true,
                      errors: {
                        ...prevState.errors,
                        actions: this.props.l10n.formatText('deeplink-builder.actions.test.error'),
                      },
                    }));
                  }}
                />
              </>
            </UitkLayoutFlex>
          </div>
        </UitkSpacing>
      </>
    );
  }
  public componentWillUnMount() {
    setTimeout(() => this.setState({ message: '' }), 3000);
  }
}
